import { message } from 'antd';

/**
 * Display a message alert to the user
 * @param messageToShow - The message to display
 * @param type - The type of message (success, warning, or error)
 * @param duration - How long to display the message in seconds
 * @param key - Optional stable id. Two calls with the same key replace one
 *   another instead of stacking — use for deduping the same alert across
 *   multiple simultaneous hook instances.
 */
export const alertMessage = (
  messageToShow: string,
  type: 'error' | 'success' | 'warning' = 'success',
  duration = 2,
  key?: string
): void => {
  const config = { content: messageToShow, duration, key };
  switch (type) {
    case 'warning': {
      message.warning(config);
      return;
    }
    case 'error': {
      message.error(config);
      return;
    }
    default: {
      message.success(config);
    }
  }
};
